<template>
  <TheMain />
</template>

<script>
import TheMain from "./components/UI/TheMain.vue";
export default {
  name: "App",
  components: {
    TheMain,
  },
};
</script>

<style lang="scss">
button,
.btn-m {
  padding: 0.5rem;
  margin: 0.2rem;
  border: 1px solid #f1f1f1;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  font-weight: 100;
  font-size: 0.9rem;
  transition: all 0.4s;
  color: #333;
  background-color: #eee;
  &:hover {
    background-color: hsl(198, 48%, 67%);
    color: #fff;
  }
}
.btn-m {
  text-decoration: none;
}
.unpointable {
  pointer-events: none;
}
.unselectable {
  user-select: none;
}
.pointer:hover {
  cursor: pointer;
}

.accordion-button {
  color: #fff !important;
  background-color: #9b9b9b !important;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif !important;
  font-weight: 100 !important;
  font-size: 0.9rem !important;
}
.accordion-button:hover {
  color: rgb(255, 255, 255) !important;
  background-color: #5c5c5c !important;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif !important;
  font-weight: 100 !important;
  font-size: 0.9rem !important;
}

.accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
}

.accordion-button:not(.collapsed) {
  color: #fff !important;
  background-color: hsl(0, 0%, 17%) !important;
}
.accordion-button:focus {
  z-index: 3;
  border-color: #ffffff !important;
  outline: 0;
  box-shadow: 0 0 0 0 rgb(13 110 253 / 25%) !important;
}
label {
  display: block !important;
  // padding: 1rem 0 !important;
}
.form-check-input {
  margin: 0.3rem 0.4rem 0 0 !important;
}
.form-check-label {
  font-size: 1rem;
  font-weight: 500;
}
.db__calendar_header {
  display: flex;
}
</style>

<style lang="scss">
.dp-date-error {
  box-shadow: 0 0 10px #d21919, 0 0 10px #d21919 !important;
  color: #d21919 !important;
  &:hover {
    border-color: #d21919;
  }
}
.dp-tipologia-error {
  box-shadow: 0 0 10px #d21919, 0 0 10px #d21919 !important;
  &:hover {
    border-color: #d21919;
  }
}
.dp-tipipersona-error {
  box-shadow: 0 0 10px #d21919, 0 0 10px #d21919 !important;
  &:hover {
    border-color: #d21919;
  }
}
.dp-tipipersona-error:not(.collapsed) {
  border: 1px solid;
  border-color: #d21919;
  box-shadow: 0 0 10px #d21919, 0 0 10px #d21919 !important;
}
.dp-tab-error {
  box-shadow: 5px -5px 5px #d21919, -5px -5px 5px #d21919 !important;
  color: #d21919 !important;
  z-index: 2;
  &:hover {
    border-color: #d21919;
  }
}
.dp-button-error {
  box-shadow: 10px 10px 10px #d21919, 10px -10px 10px #d21919,
    -10px 10px 10px #d21919, -10px -10px 10px #d21919 !important;
  color: #ffffff !important;
  border: 3px solid red;
  &:hover {
    border-color: #d21919;
    background-color: #90a77b !important;
    box-shadow: 10px 10px 10px #68a133, 10px -10px 10px #68a133,
      -10px 10px 10px #68a133, -10px -10px 10px #68a133 !important;
  }
}

*::-webkit-scrollbar {
  width: 12px; /* width of the entire scrollbar */
}

*::-webkit-scrollbar-track {
  background: rgb(219, 219, 219); /* color of the tracking area */
}

*::-webkit-scrollbar-thumb {
  background-color: rgb(119, 119, 119); /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid rgb(219, 219, 219); /* creates padding around scroll thumb */
}

.noscroll {
  overflow: hidden;
}

.p-datatable .p-datatable-tbody > tr > td {
  padding: 0.2rem 1rem !important;
}

.p-dialog-header-icons {
  position: relative;
  right: 0;
  margin-left: auto;
}

.p-confirm-dialog-message {
  white-space: pre-line;
}
.row>img {
  width: auto;
}
</style>
